import React from "react";
import PropTypes from "prop-types";

import css from "./index.module.scss";


const Column = props => {
  const className = [css[props.direction], props.className].join(" ");

  if (props.onClick) {
    return (
      <div
        className={className}
        style={props.style}
        onClick={props.onClick}
        onKeyDown={event => (event.key === "Enter" || event.key === " ") && props.onClick(event)}
        role="button"
        tabIndex={0}
      >
        {props.children}
      </div>
    );
  }

  return (
    <div className={className} style={props.style}>
      {props.children}
    </div>
  );
};

Column.defaultProps = {
  className: "",
  direction: "tl"
};

Column.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(["bc", "bl", "br", "cc", "cl", "cr", "tc", "tl", "tr"]),
  onClick: PropTypes.func,
  style: PropTypes.object
};

export default Column;